/* eslint-disable import/prefer-default-export */

// A browser's network flag is only a hint. Probe the network independently,
// and never persist connectivity across browser/tablet restarts.
const CONNECTION_STATUS_TTL = 10 * 1000;
let lastStatus = null;
let lastCheck = 0;
let pendingCheck = null;

export const withTimeout = (promise, timeout = 10000) => {
    let timer;
    return Promise.race([
        promise,
        new Promise((resolve, reject) => {
            timer = setTimeout(
                () => reject(new Error('Délai réseau dépassé')),
                timeout,
            );
        }),
    ]).finally(() => clearTimeout(timer));
};

// Includes response body consumption in the deadline and aborts where supported.
export const fetchJSON = async (url, timeout = 10000) => {
    const controller =
        typeof AbortController !== 'undefined' ? new AbortController() : null;
    try {
        return await withTimeout(
            fetch(url, {
                cache: 'no-store',
                ...(controller ? { signal: controller.signal } : {}),
            }).then((response) => {
                if (!response.ok)
                    throw new Error(`Erreur HTTP ${response.status}`);
                return response.json();
            }),
            timeout,
        );
    } finally {
        if (controller) controller.abort();
    }
};

const resetConnectionStatus = () => {
    lastStatus = null;
    lastCheck = 0;
};

if (typeof window !== 'undefined') {
    window.addEventListener('online', resetConnectionStatus);
    window.addEventListener('offline', resetConnectionStatus);
}

export const checkInternetConnection = () => {
    if (pendingCheck) return pendingCheck;
    if (lastStatus !== null && Date.now() - lastCheck < CONNECTION_STATUS_TTL) {
        return Promise.resolve(lastStatus);
    }
    const controller =
        typeof AbortController !== 'undefined' ? new AbortController() : null;
    pendingCheck = withTimeout(
        fetch(`https://www.gstatic.com/generate_204?t=${Date.now()}`, {
            mode: 'no-cors',
            cache: 'no-store',
            ...(controller ? { signal: controller.signal } : {}),
        }).then(() => true),
        3000,
    )
        .catch(() => false)
        .then((status) => {
            lastStatus = status;
            lastCheck = Date.now();
            return status;
        })
        .finally(() => {
            if (controller) controller.abort();
            pendingCheck = null;
        });
    return pendingCheck;
};
